import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/homeData';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    setTimeout(() => setIsTransitioning(false), 700);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentSlide + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide, goToSlide]);

  const slide = heroSlides[currentSlide];

  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      <div className="absolute inset-0 transition-opacity duration-700">
        <img
          src={slide.image}
          alt={slide.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-white/70 text-sm md:text-base tracking-[0.3em] uppercase mb-4 opacity-0 animate-[fadeInUp_0.8s_ease_forwards]">
              {slide.subtitle}
            </p>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight opacity-0 animate-[fadeInUp_0.8s_0.15s_ease_forwards]">
              {slide.title}
            </h1>
            <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed opacity-0 animate-[fadeInUp_0.8s_0.3s_ease_forwards]">
              {slide.description}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 opacity-0 animate-[fadeInUp_0.8s_0.45s_ease_forwards]">
              <Link
                to="/category"
                className="px-8 py-3 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                探索服务
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-md text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解品牌
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-white w-8'
                : 'bg-white/40 hover:bg-white/70'
            }`}
            aria-label={`跳转到第${index + 1}张`}
          />
        ))}
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}